<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchAllRoles"
      :table-columns="tableColumns"
      :pagination="false"
      :searchable="false"
      @onGroupDelete="groupDelete"
    >

      <template #cell(roleName)="{ item }">
        {{ item.roleName === 'admin' ? 'مدیر' : '' }}
        {{ item.roleName === 'Consultants' ? 'مشاور' : '' }}
        {{ item.roleName === 'user' ? 'کاربر' : '' }}
        {{ item.roleName === 'writer' ? 'نویسنده' : '' }}
        {{ item.roleName === 'Labs' ? 'آزمایشگاه' : '' }}
        {{ item.roleName === 'Institutes' ? 'آزمایشگاه' : '' }}
        {{ item.roleName === 'Lab Mag' ? 'آزمایشگاه بلاگ' : '' }}
        {{ item.roleName === 'Human Resource' ? 'منابع انسانی' : '' }}
        {{ item.roleName === 'editor' ? 'ویراستار' : '' }}
        {{ item.roleName === 'Lab Consult' ? 'مشاور آزمایشگاه' : '' }}
        {{ item.roleName === 'ewex' ? 'ewex' : '' }}
        {{ item.roleName === 'Feedback manager' ? 'نظرات' : '' }}
      </template>
      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row v-if="$can('manage', 'all')" @click.native="toEditPage(item._id)" />
        <delete-row v-if="$can('manage', 'all')" @click.native="deleteItem(item._id)" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import BDataTable from '@/components/BDataTable/index.vue'
import DeleteRow from '@/components/BDataTable/Actions/DeleteRow.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import useRolesList from './useRolesList'

export default {
  name: 'RolesList',
  components: {
    BDataTable,
    DeleteRow,
    EditRow,
    LayoutLoading,
  },
  setup() {
    const {
      deleteItem,
      fetchAllRoles,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    } = useRolesList()

    return {
      deleteItem,
      fetchAllRoles,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    }
  },
}
</script>
